import { render, staticRenderFns } from "./BloodTypesTable.vue?vue&type=template&id=45d3e2e2&"
import script from "./BloodTypesTable.vue?vue&type=script&lang=js&"
export * from "./BloodTypesTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports